export const GOOGLE_ANALYTICS_ID = 'G-YPZFSF1LSC';

export const ANALYTICS_METRICS = {
  time_session_trial_initiated: 'time_session_trial_initiated',
  time_language_select_success: 'time_language_select_success',
  time_style_selected: 'time_style_selected',
  time_photo_initiated: 'time_photo_initiated',

  time_photo_selection_initiated: 'time_photo_selection_initiated',
  time_photo_selection_success: 'time_photo_selection_success',
  time_face_selection_initiated: 'time_face_selection_initiated',
  time_face_selection_success: 'time_face_selection_success',
  time_demographics_confirmed: 'time_demographics_confirmed',

  time_photo_upload: 'time_photo_upload',
  time_portraits_generated_some: 'time_portraits_generated_some',
  time_portraits_generated_all: 'time_portraits_generated_all',
  time_portraits_engaged: 'time_portraits_engaged',
  time_portraits_picked: 'time_portraits_picked',

  time_printing_initiated: 'time_printing_initiated',
  time_printing_confirmed: 'time_printing_confirmed',
  time_printing_printed_some: 'time_printing_printed_some',
  time_printing_printed_all: 'time_printing_printed_all',
  num_images_printed: 'num_images_printed',
  time_download_initiated: 'time_download_initiated',
  time_download_used: 'time_download_used',

  device_uuid: 'device_uuid',

  source: 'source',
  source_partner: 'source_partner',
  source_kiosk_id: 'source_kiosk_id',
  source_is_mini_pc: 'source_is_mini_pc',

  remote_ip: 'remote_ip',
  user_agent: 'user_agent',
  user_agent_is_mobile: 'user_agent_is_mobile',
  platform: 'platform',
  browser: 'browser',
  screen_width: 'screen_width',
  screen_height: 'screen_height',
  country_code: 'country_code',

  num_faces_detected: 'num_faces_detected',
  style_id: 'style_id',

  age_group: 'age_group',
  race: 'race',
  gender: 'gender',
  demographics_changed: 'demographics_changed',
  has_multiple_people: 'has_multiple_people',

  session_engaged: 'session_engaged',
  session_open_dev_panel: 'session_open_dev_panel',
  session_idle: 'session_idle',
  session_idle_reset: 'session_idle_reset',
  session_manual_reset: 'session_manual_reset',

  language_select_initiated: 'language_select_initiated',
  language_initial: 'language_initial',
  language_selected: 'language_selected',

  price_per_portrait: 'price_per_portrait',
  price_currency: 'price_currency',

  download_engaged: 'download_engaged',
  download_download_clicked: 'download_download_clicked',
  download_send_or_share_clicked: 'download_send_or_share_clicked',
};
